export const highestSpikeTrendAnalysisChartOptions = (data, dates) => {
    const { start, end } = dates;
    return {
        title: {
            left: 'left',
            text: 'Trend Analysis',
            textStyle: {
                color: '#244B60',
                fontSize: '12px'
            }
        },
        grid: {
            height: '45%'
        },
        xAxis: [
            {
                data:
                    start && end
                        ? [
                              `${start.monthText}-${start.year.slice(-2)}`,
                              `${end.monthText}-${end.year.slice(-2)}`
                          ]
                        : [],
                name: 'Creation Date',
                nameLocation: 'center',
                nameTextStyle: {
                    padding: [20, 0, 0, 0],
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12,
                    width: '100%'
                },
                nameGap: 28,
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                }
            }
        ],
        yAxis: [
            {
                name: 'Total Risk Score',
                nameLocation: 'center',
                nameTextStyle: {
                    color: '#7FADBF',
                    fontWeight: 600,
                    fontSize: 12
                },
                axisLabel: {
                    show: false
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: false
                },
                min: data.startMonthScore * 0.5
            }
        ],
        series: [
            {
                type: 'line',
                symbolSize: [7, 7],
                data: [data.startMonthScore, data.endMonthScore],
                lineStyle: {
                    color: '#929292'
                },
                itemStyle: {
                    color: '#929292'
                },
                label: {
                    show: true,
                    position: 'top',
                    fontSize: 10,
                    fontWeight: 700,
                    lineheight: 14
                },
                boundaryGap: false
            }
        ]
    };
};
